import {
	deleteAchievement,
	getAchievementCategories,
	getAchievements,
	saveAchievement,
	updateAchievement,
} from '@/services/main/gamification.service'

export default {
	namespaced: true,
	state: {
		achievementList: { meta: { total: 0 } },
		achievementStatus: 'init',
		categoryList: [],
	},
	getters: {
		getAchievementList: (state) => state.achievementList,
		getAchievementStatus: (state) => state.achievementStatus,
		getCategoryList: (state) => state.categoryList,
	},
	mutations: {
		SET_ACHIEVEMENT_LIST(state, val) {
			state.achievementList = val
		},
		SET_ACHIEVEMENT_STATUS(state, val) {
			state.achievementStatus = val
		},
		SET_CATEGORY_LIST(state, val) {
			state.categoryList = val
		},
	},
	actions: {
		async fetchAchievements({ commit }, params) {
			commit('SET_ACHIEVEMENT_STATUS', 'pending')
			try {
				const { data } = await getAchievements(params)
				commit('SET_ACHIEVEMENT_LIST', data)
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				throw error
			}
		},
		async fetchCategories({ commit }, params) {
			try {
				const { data } = await getAchievementCategories(params)
				commit('SET_CATEGORY_LIST', data.data || data)
				return data
			} catch (error) {
				throw error
			}
		},
		async saveAchievement({ commit }, params) {
			commit('SET_ACHIEVEMENT_STATUS', 'pending')
			try {
				const { data } = await saveAchievement(params)
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				throw error
			}
		},
		async updateAchievement({ commit }, { id, ...params }) {
			commit('SET_ACHIEVEMENT_STATUS', 'pending')
			try {
				const { data } = await updateAchievement(id, params)
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				throw error
			}
		},
		async deleteAchievement({ commit }, id) {
			commit('SET_ACHIEVEMENT_STATUS', 'pending')
			try {
				const { data } = await deleteAchievement(id)
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				return data
			} catch (error) {
				commit('SET_ACHIEVEMENT_STATUS', 'init')
				throw error
			}
		},
	},
}
